import ReportsSerializer from './base';

export default class StudentReport extends ReportsSerializer {}
